module.exports = __webpack_public_path__ + "img/pontuei-logo-i.8ad3cd10.png";